import { render } from "./DialogInvalidUseInterval.vue?vue&type=template&id=e1221c70"
import script from "./DialogInvalidUseInterval.vue?vue&type=script&lang=js"
export * from "./DialogInvalidUseInterval.vue?vue&type=script&lang=js"
script.render = render

export default script